import { Caption, Heading, LayoutSpaceVertical, Skeleton } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export const CreditTile = ({
  children,
  isLoading
}) => /*#__PURE__*/_jsx(LayoutSpaceVertical, {
  background: "background-color",
  borderRadius: "border-radius",
  gap: "space-xxs",
  padding: "space",
  children: /*#__PURE__*/_jsx(Skeleton, {
    blockSize: "2.625rem",
    inlineSize: "100%",
    isLoading: isLoading,
    variant: "light",
    children: children
  })
});
CreditTile.Count = ({
  children,
  hasLowCredits
}) => /*#__PURE__*/_jsx(Heading, {
  as: "h5",
  color: hasLowCredits ? 'danger' : 'base',
  children: children
});
CreditTile.Label = ({
  children
}) => /*#__PURE__*/_jsx(Caption, {
  as: "div",
  margin: "0",
  children: children
});